var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('meta',{attrs:{"name":"All github commit numberg","latest-commit-number":_vm.latestCommitNumber}}),_c('meta',{attrs:{"name":"All github tag","latest-tag":_vm.latestTag}}),_c('header-toolbar'),_c('transition',{attrs:{"name":"fade"}},[_c('router-view')],1),_c('footer-toolbar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }